var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { createElement, useEffect, useState } from "react";
import { Box, Button, Grid, InputAdornment, TextField, Typography, } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useCheckoutContext } from "../../../context/useCheckoutContext";
import { Translate as T } from "react-localize-redux";
import Lock from "../../../assets/logos/Lock";
import InputMask from "react-input-mask";
import TermsConditions from "../../commons/TermsConditions/TermsConditions";
import { DeferredOptions } from "../../commons/DeferredOptions/DeferredOptions";
import { useKPayCvvState } from "./state/useKPayCvvState";
import CheckIcon from "@material-ui/icons/Check";
import { HeaderPayment } from "../../commons/HeaderPayment/HeaderPayment";
import { getCardBrand } from "../../../utils/utils";
import { CardsEnum } from "../../../shared/constants/CardsEnum";
import { PaymentTypeEnum } from "../../../shared/constants/PaymentTypeEnum";
var useStyles = makeStyles(function (theme) { return ({
    button: {
        backgroundColor: "",
        borderRadius: 8,
        fontSize: "16px",
        height: "48px",
    },
    checkIcon: {
        alignItems: "center",
        background: "#EEF6FF",
        borderRadius: "50%",
        display: "flex",
        height: "33px",
        justifyContent: "center",
        width: "33px",
    },
    savedCardwrapper: {
        border: "1px solid rgba(2, 51, 101, 0.1)",
        borderRadius: "8px",
        margin: "20px 0",
        padding: "13px 21px",
        position: "relative",
    },
    icon: {
        width: theme.spacing(5.5),
        height: theme.spacing(3.5),
    },
}); });
export var KPayCvv = function () {
    var _a = useState(), card = _a[0], setCard = _a[1];
    var _b = useState(), cardLogo = _b[0], setCardLogo = _b[1];
    var _c = useCheckoutContext(), kpaySelectedPayment = _c.kpaySelectedPayment, isMobile = _c.isMobile, paymentType = _c.paymentType;
    var classes = useStyles();
    var _d = useKPayCvvState(), form = _d.form, handler = _d.handler, deferredOptions = _d.deferredOptions, openTerms = _d.openTerms, brands = _d.brands, deferredCurrentValues = _d.deferredCurrentValues;
    useEffect(function () {
        if ((kpaySelectedPayment === null || kpaySelectedPayment === void 0 ? void 0 : kpaySelectedPayment.kind) === "card") {
            setCard(kpaySelectedPayment);
            var brand = kpaySelectedPayment.brand
                ? kpaySelectedPayment.brand.toLowerCase()
                : CardsEnum.visa;
            var logo = getCardBrand(brand);
            if (logo)
                setCardLogo(logo);
        }
    }, [kpaySelectedPayment]);
    return (React.createElement(Box, { py: "24px", px: "15px" },
        React.createElement(Grid, { container: true },
            React.createElement(HeaderPayment, { logos: brands }),
            React.createElement("form", { onSubmit: form.handleSubmit(handler.handleSubmit), style: { width: "100%" } },
                React.createElement(T, null, function (_a) {
                    var translate = _a.translate;
                    return (React.createElement(React.Fragment, null,
                        React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(Box, { className: classes.savedCardwrapper },
                                React.createElement(Grid, { container: true, alignItems: "center", justify: "space-between" },
                                    React.createElement(Grid, { item: true },
                                        React.createElement(Grid, { container: true, spacing: 2, alignItems: "center" },
                                            React.createElement(Grid, { item: true }, cardLogo &&
                                                createElement(cardLogo.image, {
                                                    className: classes.icon,
                                                })),
                                            React.createElement(Grid, { item: true },
                                                React.createElement(Typography, { style: { fontSize: "14px" } }, card === null || card === void 0 ? void 0 : card.cardHolderName),
                                                React.createElement(Typography, { style: { fontSize: "14px" } }, "**** " + (card === null || card === void 0 ? void 0 : card.lastFourDigits))))),
                                    React.createElement(Grid, { item: true },
                                        React.createElement(Box, { className: classes.checkIcon },
                                            React.createElement(CheckIcon, { color: "primary" })))))),
                        React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(InputMask, { mask: "9999", maskChar: null }, function (inputProps) { return (React.createElement(TextField, __assign({}, inputProps, { placeholder: translate("cardCheckout.CVC"), name: "cvc", error: !!form.errors["cvc"], type: "password", style: { marginBottom: "24px", paddingLeft: 3 }, variant: "outlined", margin: "none", helperText: !!form.errors["cvc"] && form.errors["cvc"].message, InputProps: {
                                    startAdornment: (React.createElement(InputAdornment, { position: "start" },
                                        React.createElement(Lock, null))),
                                }, inputRef: form.register({
                                    required: {
                                        message: translate("form.fieldRequired"),
                                        value: true,
                                    },
                                }) }))); })),
                        paymentType !== PaymentTypeEnum.SUBSCRIPTION && (React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(DeferredOptions, { deferredOptions: {
                                    hasDeferred: deferredOptions.hasDeferred,
                                    isActive: deferredOptions.isActive,
                                    isDynamic: deferredOptions.isDynamic,
                                    months: deferredOptions.months,
                                    monthsOfGrace: deferredOptions.monthsOfGrace,
                                    showDeferredTypes: deferredOptions.showDeferredTypes,
                                    typesDeferred: deferredOptions.typesDeferred,
                                }, currentValues: deferredCurrentValues, isMobile: isMobile, handleSetFields: handler.handleSetFields, form: form }))),
                        React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(TermsConditions, { form: form, setOpenTerms: handler.handleOpenTerms, open: openTerms })),
                        React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(Box, { display: "flex", justifyContent: "center", mt: "24px" },
                                React.createElement(Button, { type: "submit", variant: "contained", fullWidth: true, color: "primary", className: classes.button },
                                    React.createElement(T, { id: "payButton" }))))));
                })))));
};
